export const panelManufacturers = {
  "AE Solar": ["aesolar", "Aesolar", "AE Solar"],
  "AIKO": ["Aiko"],
  "Akcome": ["AKCOME"],
  "Astronergy": ["ASTRONERGY", "Astroenergy", "Astro"],
  "Axitec": ["AXI"],
  "Bauer": ["bauer", "BAUER"],
  "Beyondsun": ["beyondsun", "BEYONDSUN"],
  "Bluesun": ["BLUESUN", "bluesun"],
  "Canadian Solar": ["CanadianSolar", "Canadian"],
  "DAH Solar": ["Dah Solar", "DAH", "dahsolar", "DAHSOLAR", "Dahsolar"],
  "DAS Solar": ["DAS SOLAR", "Das Solar", "Dassolar"],
  "Encor": ["ENCOR", "encor", "CorabEncor", "CORAB", "Corab"],
  "FuturaSun": ["FUTURASUN", "futurasun", "Futurasun"],
  "GOKIN": ["GOKIN", "Gokin", "gokin"],
  "Hanersun": ["Hanersun", "hanersun", "HANERSUN"],
  "Huasun": ["HUASUN", "huasun"],
  "Hyundai": ["hyundai", "HYUNDAI"],
  "IBC": ["ibc", "Ibc"],
  "JA Solar": ["JA SOLAR", "Ja Solar", "ja solar", "JaSolar", "JASOLAR", "jasolar", "JAM"],
  "Jetion": ["jetion", "JETION"],
  "Jinko Solar": ["JINKO", "Jinko", "jinko", "JKM"],
  "Jolywood": ["JOLYWOOD"],
  "Kensol": ["KENSOL"],
  "LG": ["NeON", "lg"],
  "Leapton Solar": ["LEAPTON SOLAR", "LEAPTON", "leapton", "Leapton"],
  "Ledvance": ["LEDVANCE", "ledvance"],
  "LONGi Solar": ["LONGI", "Longi", "LONGi", "72HIBD"],
  "Luxor Solar": ["LUXOR", "LUXORSOLAR", "luxorsolar", "LuxorSolar", "Luxorsolar", "LUXOR SOLAR", "Luxor"],
  "Meyer Burger": ["Meyer", "MeyerBurger", "Meyerburger"],
  "Phono Solar": ["PHONO", "PhonoSolar", "Phonosolar"],
  "QCells": ["Q-Cells", "Q-CELLS", "Q Cells", "Q CELLS", "Q PEAK", "Q‑CELLS", "Q.PEAK", "QCELLS"],
  "REC": ["Rec", "TwinPeak"],
  "Risen": ["RISEN", "risen"],
  "Saronic": ["SARONIC"],
  "Selfa": ["SELFA", "selfa"],
  "Sharp": ["SHARP", "sharp"],
  "SoliTek": ["Soli Tek", "solitek", "SOLITEK"],
  "SunLink": ["Sunlink", "SUNLINK"],
  "Sunova": ["sunova", "SUNOVA"],
  "SunPower": ["sunpower", "SUNPOWER", "SUN-POWER", "Sun-Power"],
  "Suntech": ["suntech", "SUNTECH"],
  "Swiss Solar": ["SWISS SOLAR"],
  "Tongwei": ["TW Solar", "tongwei", "TONGWEI"],
  "Trina Solar": ["Trina", "TRINA", "Vertex"],
  "Ulica Solar": ["UlicaSolar", "Ulica Solar"],
  "Viessmann": ["VIESSMANN", "viessmann"],
  "V-TAC": ["v-tac", "V-tac", "V-Tac", "VTAC", "vtac"],
  "ZnShine": ["znshine", "Znshine"],
  "DMEGC": ["DMEGC", "dmegc"],
  "TCL": ["TCL"],
  "AVIA Solar": ["AVIA SOLAR", "avia solar"],
  "HT-SAAE": ["HT-SAAE", "SAAE"],
  "HY Solar": ["HY Solar", "HY-NT"],
  "Q-SUN": ["Q-SUN"]
}

export const panelSellers = {
  Megawat: 'Megawat',
  PVHurt: 'PVHurt',
  PVMet: 'PVMet',
  'Twoja fotowoltaika': 'Twoja fotowoltaika',
  Voltforce: 'Voltforce',
  '7sun': '7Sun',
  Klifenergy: 'Klif Energy',
  Soltech: 'Sklep Soltech',
  Alians: 'Alians',
  Helpes: 'Helpes',
  Kontaktuj: 'Kontaktuj',
  Swatt: 'SWATT',
  EcoSystem: 'Ecosystem Projekt',
  'Solar-EM': 'Solar-EM',
  SklepSolar: 'SklepSolar',
  'PRO-POWER-TECH': 'PRO-POWER-TECH',
  NowaElektro: 'Nowa Elektro',
  EcoGral: 'EcoGral',
  Corab: 'Corab',
  'Avia Solar': 'Avia Solar',
  EcoABM: 'EcoABM',
  GVOLT: 'GVOLT',
  Grodno: 'Grodno',
  Solfinity: 'Solfinity',
  BayWa: 'BayWa',
  'IBC Solar': 'IBC Solar',
  'Hurtownia Solarna': 'Hurtownia Solarna',
  Enexon: 'Enexon',
  Virtech: 'Virtech',
  MasterEnergy: 'MasterEnergy',
  OneOn: 'OneOn',
  Solvolte: 'Solvolte',
  PanPower: 'PanPower',
  Elektryk: 'Elektryk',
  'Solarne.info': 'Solarne.info',
  'PV Zenit': 'PV Zenit',
  TIM: 'TIM',
  Besteon: 'Besteon',
  'Marven Solar': 'Marven Solar',
  'Solution Energy Storage': 'Solution Energy Storage',
};

export const inverterSellers = {
  '7sun': '7Sun',
  'Twoja fotowoltaika': 'Twoja fotowoltaika',
  'Sofar Sklep': 'Sofar Sklep',
  'Super Energy': 'Super Energy',
  SklepSolar: 'SklepSolar',
  'Solar-EM': 'Solar-EM',
  'PRO-POWER-TECH': 'PRO-POWER-TECH',
  EcoGral: 'EcoGral',
  Grodno: 'Grodno',
  Solfinity: 'Solfinity',
  BayWa: 'BayWa',
  Corab: 'Corab',
  'Avia Solar': 'Avia Solar',
  'IBC Solar': 'IBC Solar',
  Alians: 'Alians',
  PVHurt: 'PVHurt',
  Soltech: 'Sklep Soltech',
  SolarMarket24: 'SolarMarket24',
  Voltforce: 'Voltforce',
  Megawat: 'Megawat',
  Kontaktuj: 'Kontaktuj',
  NowaElektro: 'Nowa Elektro',
  'Hurtownia Solarna': 'Hurtownia Solarna',
  Enexon: 'Enexon',
  Virtech: 'Virtech',
  MasterEnergy: 'MasterEnergy',
  OneOn: 'OneOn',
  Solvolte: 'Solvolte',
  PanPower: 'PanPower',
  Elektryk: 'Elektryk',
  'Solarne.info': 'Solarne.info',
  'PV Zenit': 'PV Zenit',
  EcoSystem: 'Ecosystem Projekt',
  PVGroup: 'PVGroup',
  TIM: 'TIM',
  Besteon: 'Besteon',
  'Marven Solar': 'Marven Solar',
  'Solution Energy Storage': 'Solution Energy Storage',
  'Master Energy PL': 'Master Energy PL',
};

export const magazineSellers = {
  '7sun': '7Sun',
  'Twoja fotowoltaika': 'Twoja fotowoltaika',
  EcoGral: 'EcoGral',
  Grodno: 'Grodno',
  Solfinity: 'Solfinity',
  BayWa: 'BayWa',
  Corab: 'Corab',
  'Avia Solar': 'Avia Solar',
  'IBC Solar': 'IBC Solar',
  Alians: 'Alians',
  PVHurt: 'PVHurt',
  Soltech: 'Sklep Soltech',
  Megawat: 'Megawat',
  'J-Point': 'J-Point',
  Voltforce: 'Voltforce',
  Kontaktuj: 'Kontaktuj',
  NowaElektro: 'Nowa Elektro',
  'Super Energy': 'Super Energy',
  SklepSolar: 'SklepSolar',
  Helpes: 'Helpes',
  'Kon-TEC': 'Kon-TEC',
  'Hurtownia Solarna': 'Hurtownia Solarna',
  Enexon: 'Enexon',
  Kwant: 'Kwant',
  Virtech: 'Virtech',
  MasterEnergy: 'MasterEnergy',
  OneOn: 'OneOn',
  Solvolte: 'Solvolte',
  PanPower: 'PanPower',
  Elektryk: 'Elektryk',
  'PV Zenit': 'PV Zenit',
  EcoSystem: 'Ecosystem Projekt',
  PVGroup: 'PVGroup',
  TIM: 'TIM',
  Besteon: 'Besteon',
  'Marven Solar': 'Marven Solar',
  'Solution Energy Storage': 'Solution Energy Storage',
  'Master Energy PL': 'Master Energy PL',
};

export const inverterManufacturers = {
  "Afore": ["afore", "AFORE", "HNS"],
  "APsystems": ["apsystems", "APSYSTEMS", "Apsystems", "ap-systems", "ap-system"],
  "Avrii": ["avrii", "AVRII", "Avri", "avri", "AVRI"],
  "Deye": ["deye", "DEYE", "deyesun", "Deyesun", "DEYESUN", "DEYESun", "deyesun"],
  "Ecoflow": ["ecoflow", "ECOFLOW", "EcoFlow"],
  "Encor": ["encor", "ENCOR", "Corab", "CORAB", "Corabencor", "CorabEncor"],
  "Enphase": ["enphase", "ENPHASE"],
  "FoxESS": ["foxess", "FOXESS", "Foxess", "FoxEss", "Fox", "Foxes"],
  "Fronius": ["fronius", "FRONIUS", "Tauro", "Symo", "Primo"],
  "KACO": ["KACO", "BLUEPLANET"],
  "Anker": ["ANKER", "SOLIX"],
  "Pylontech": ["PYLONTECH", "PYLON TECH"],
  "General Electric": ["general electric", "General-Electric", "GENERAL ELECTRIC"],
  "GoodWe": ["GOODWE", "goodwe", "GODWE", "godwe", "goodwee", "GOODWEE", "Goodwee"],
  "Growatt": ["growatt", "GROWATT", "growat", "GROWAT"],
  "Hoymiles": ["hoymiles", "HOYMILES", "HoyMiles"],
  "Hypontech": ["hypontech", "HYPONTECH", "HyponTech"],
  "Huawei": ["HUAWEI", "huawei", "SUN2000", "Sun2000"],
  "Kehua Tech": ["kehua", "KEHUA", "Kehuatech", "KehuaTech", "kehuatech", "KEHUATECH", "Kehua"],
  "Kostal": ["KOSTAL", "kostal"],
  "KSTAR": ["kstar", "KSG"],
  "Ledvance": ["LEDVANCE", "ledvance"],
  "RCT POWER": ["RCT", "RCTPOWER", "Rctpower", "RCT-Power", "RCT-POWER"],
  "Selfa": ["SELFA", "selfa"],
  // 28 modeli w katalogu (2026-10-01), a marki brakowało w filtrze, więc nie dało się jej wybrać.
  "Sigenergy": ["Sigenergy", "SIGENERGY", "Sigen", "SigenStor"],
  "SMA": ["STP", "SMA "],
  "Sofar": ["SOFAR", "sofar", "Sofarsolar", "sofarsolar", "SOFARSOLAR", "SofarSolar"],
  "Solax": ["solax", "SOLAX", "SolaxPower", "Solaxpower", "solaxpower", "Solax-Power", "SOLAXPower", "SOLAX-Power"],
  "SolarEdge": ["solaredge", "Solaredge", "Solar edge", "Solar Edge", "SOLAREDGE", "HD Wave", "solar-edge", "Solar-Edge", "Solar-edge"],
  "Solplanet": ["solplanet", "SOLPLANET", "SolPlanet"],
  "Solis": ["solis", "SOLIS"],
  "Sungrow": ["sungrow", "SUNGROW", "SunGrow"],
  "Sunwoda": ["Sunwoda", "SUNWODA", "SunESS", "Atrix"],
  "WHES": ["WHES"],
  "GSL Energy": ["GSL Energy", "GSL"],
  "Hinen": ["Hinen"],
  "Miellec": ["Miellec"],
  "SunWays": ["Sunways", "sunways", "SUNWAYS"],
  "Tigo": ["tigo", "TIGO"],
  "Victron Energy": ["VICTRON", "Victron", "VictronEnergy", "Victronenergy", "VICTRONENERGY", "Victron-energy", "victron-energy", "Phoenix Inverter", "Smart", "smart", "Phoenix"],
  "VoltPolska": ["SINUS PRO", "voltpolska", "VOLTPOLSKA", "Volt Polska"],
  "Livoltek": ["Livoltek"],
  "AlphaESS": ["AlphaESS", "Alpha ESS"],
  "V-TAC": ["V-TAC", "VTAC"],
  "Chisage": ["Chisage"],
  "Steca": ["Steca"],
  "TSUN": ["TSUN"]
}

// Schematy filtrów listingów. `title`, `hint` i etykiety w `values` to polski tekst
// domyślny: Filters.jsx pokazuje je przez lista:filtry.schemat.* (tytul, podpowiedz,
// wartosci.<name>.<klucz>). Klucze `values` idą do API jako wartości z bazy, więc
// zostają bez zmian w każdej wersji językowej.
export const panelFiltersSchema = [
  // {
  //   title: 'Cena',
  //   type: 'range',
  //   name: 'price',
  //   min: 0,
  //   max: 1000,
  // },
  // {
  //   title: 'Moc',
  //   type: 'input',
  //   name: 'power',
  //   min: 0,
  //   max: 1000,
  // },
  {
    title: 'Producent',
    type: 'checkbox',
    name: 'manufacturer',
    values: Object.keys(panelManufacturers).reduce((acc, key) => {
      acc[key] = key;
      return acc;
    }, {})
  },
  {
    title: 'Rodzaj',
    type: 'checkbox',
    name: 'types',
    values: {
      Standard: 'Standard',
      'Full Black': 'Full Black',
      Bifacial: 'Bifacial',
    }
  },
];
// Obramowanie przeniesione do sekcji zaawansowanego filtrowania w Filters.jsx

export const inverterFiltersSchema = [
  {
    title: 'Producent',
    type: 'checkbox',
    name: 'manufacturer',
    values: Object.keys(inverterManufacturers).reduce((acc, key) => {
      acc[key] = key;
      return acc;
    }, {})
  },
  {
    title: 'Rodzaj',
    type: 'checkbox',
    name: 'types',
    values: {
      Sieciowy: 'Sieciowy',
      Hybrydowy: 'Hybrydowy',
      Mikroinwertery: 'Mikroinwertery',
      'Off-grid': 'Off-grid',
    }
  },
  {
    title: 'Fazy',
    type: 'checkbox',
    name: 'phase',
    values: {
      '1 Fazowy': '1 Fazowy',
      '3 Fazowy': '3 Fazowy',
    }
  },
  {
    title: 'Liczba MPPT',
    type: 'checkbox',
    name: 'mppt',
    values: {
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
      6: '6',
      7: '7',
      8: '8',
      9: '9',
      10: '10',
      11: '11',
      12: '12',
      13: '13',
      14: '14',
      15: '15',
    }
  },
]

/**
 * Producenci magazynów energii.
 *
 * UZUPEŁNIENIE ROZGRZEBANEJ ZMIANY: `CategorySection` importował ten eksport,
 * a plik go nie miał — przez to build (lokalny i w obrazie) się nie kompilował.
 * Lista wzięta z katalogu (`/api/magazine_models`), 33 marki, a nie z głowy.
 *
 * Wartości to warianty pisowni do dopasowania, tak jak przy pozostałych kategoriach.
 * Tu jest po jednym wariancie na markę — jeśli w danych pojawią się inne zapisy
 * (np. „PYLONTECH"), dopisz je tak samo jak w `panelManufacturers`.
 */
export const magazineManufacturers = {
  // Pieciu producentow brakowalo w filtrach, mimo ze maja oferty w katalogu
  // (Kon-TEC 20, SigenStor 7, HUA POWER 3, SunWays 2, Victron Energy 2).
  // Filtr budowany recznie zawsze bedzie sie rozjezdzal z danymi — docelowo
  // ma go zastapic lista producentow z API.
  "Anker": ["Anker"],
  // 59 ofert w katalogu. Do czasu przeliczenia danych przez potok wiekszosc z nich
  // ma pusty `manufacturer`, wiec filtr zacznie je zwracac dopiero po tym przeliczeniu
  // (poprawka w scrapers: config/mag/manufacturers.json).
  "Felicity": ["Felicity", "FelicityESS", "FLA48", "FLB48", "FLH48"],
  "HUA POWER": ["HUA POWER", "Hua Power"],
  "Kon-TEC": ["Kon-TEC", "KonTEC"],
  // Klucz musi być nazwą producenta z bazy, bo filtr wysyła go wprost. Pod kluczem
  // „SigenStor” filtr szukał marki, której w bazie nie ma (11 modeli to „Sigenergy”).
  "Sigenergy": ["Sigenergy", "SigenStor"],
  "SunWays": ["SunWays", "Sunways"],
  "Victron Energy": ["Victron Energy", "Victron"],
  "BYD": ["BYD"],
  "Breeze Energies": ["Breeze Energies"],
  "Deye": ["Deye"],
  "Dyness": ["Dyness"],
  "Encor": ["Encor"],
  "Enphase": ["Enphase"],
  "FoxESS": ["FoxESS"],
  "Fronius": ["Fronius"],
  "GSL Energy": ["GSL Energy"],
  "GoodWe": ["GoodWe"],
  "Growatt": ["Growatt"],
  "Heckman": ["Heckman"],
  "Hinen": ["Hinen"],
  "Hoymiles": ["Hoymiles"],
  "Huawei": ["Huawei"],
  "KSTAR": ["KSTAR"],
  "Kehua Tech": ["Kehua Tech"],
  "LG": ["LG"],
  "Ledvance": ["Ledvance"],
  "Miellec": ["Miellec"],
  "Pylontech": ["Pylontech"],
  "RCT POWER": ["RCT POWER"],
  "SMA": ["SMA"],
  "Sofar": ["Sofar"],
  "SolarEdge": ["SolarEdge"],
  "Solax": ["Solax"],
  "Solis": ["Solis"],
  "Solplanet": ["Solplanet"],
  "Sungrow": ["Sungrow"],
  "Sunwoda": ["Sunwoda"],
  "Tigo": ["Tigo"],
  "WHES": ["WHES"],
  "AlphaESS": ["AlphaESS"],
  "Zineric": ["Zineric"],
  "LVFU": ["LVFU"],
  "DiPower": ["DiPower"],
  "Azo Digital": ["Azo Digital"],
  "Marstek": ["Marstek"],
  "Sluxer": ["Sluxer"],
  "Chisage": ["Chisage"],
  "Livoltek": ["Livoltek"],
};

export const magazineFiltersSchema = [
  {
    title: 'Producent',
    type: 'checkbox',
    // BYŁO `inverterManufacturers` — filtr magazynów pokazywał marki FALOWNIKÓW.
    // Dlatego producenci dopisywani do `magazineManufacturers` nie pojawiali się
    // na liście: ten schemat w ogóle z tej listy nie korzystał.
    name: 'manufacturer',
    values: Object.keys(magazineManufacturers).reduce((acc, key) => {
      acc[key] = key;
      return acc;
    }, {})
  },
  {
    title: 'Rodzaj',
    type: 'checkbox',
    name: 'types',
    values: {
      "Moduł Bateryjny": 'Moduł Bateryjny',
      "BMS": 'BMS',
      "Zestaw (Magazyn + BMS)": 'Zestaw (Magazyn + BMS)',
      "All-In-One": 'All-In-One',
      "Przemysłowe": 'Przemysłowe',
    }
  },
  {
    title: 'Napięcie',
    type: 'checkbox',
    name: 'voltage',
    values: {
      Wysokonapięciowy: 'Wysokonapięciowy',
      Niskonapięciowy: 'Niskonapięciowy',
    },
    // Etykieta wysoko/nisko zostaje GŁÓWNĄ osią wyboru — tak ludzie szukają.
    // Liczbowe napięcia z kart są warstwą zaawansowaną obok niej, więc tu tylko
    // o niej mówimy, zamiast mieszać oba poziomy w jednej liście.
    hint: 'Konkretne napięcia wybierzesz w filtrowaniu zaawansowanym.',
  },
  {
    // Progi z rozkładu danych, nie z głowy: 23 modele ładują się poniżej zera
    // (-20 i -10 °C), 85 od zera, 2 dopiero powyżej. Trzeci kubełek jest opisany
    // progiem ZERA, choć dziś wszystkie modele w nim mają +5 °C — gdyby doszedł
    // model z +2, etykieta „od +5" zaczęłaby kłamać.
    title: 'Temperatura ładowania',
    type: 'checkbox',
    name: 'charge_temp_class',
    values: {
      below_zero: 'Ładuje poniżej 0 °C',
      from_zero: 'Od 0 °C',
      above_zero: 'Dopiero powyżej 0 °C',
    },
    hint: 'Zimą decyduje, czy magazyn w ogóle przyjmie energię.',
  }
]

// ===== WALLBOXY =====
// Kanoniczne nazwy marek pochodzą z wallbox_scraper/seed/wallbox_manufacturers.json.
// Docelowo ta lista ma znikać na rzecz GET /api/wallbox_facets/, który zwraca
// dostępne wartości razem z licznikami — jedno źródło prawdy zamiast dwóch kopii.
export const wallboxManufacturers = {
  'ABL': ['abl'],
  'Amina': ['amina'],
  'Autel': ['autel'],
  'Daze': ['daze'],
  'Defenzo': ['defenzo'],
  'Deye': ['deye'],
  'Doktorvolt': ['doktorvolt'],
  'Easee': ['easee'],
  'EMONE': ['emone'],
  'Enphase': ['enphase'],
  'Feyree': ['feyree'],
  'FLOWEV': ['flowev'],
  'FoxESS': ['foxess'],
  'Fronius': ['fronius', 'wattpilot'],
  'GoodWe': ['goodwe'],
  'go-e': ['go-e'],
  'Green Cell': ['greencell', 'green cell', 'habuden'],
  'GRESGYING': ['gresgying'],
  'Growatt': ['growatt'],
  'Huawei': ['huawei'],
  'LECTRI': ['lectri'],
  'Lenergizee': ['lenergizee'],
  'myenergi': ['myenergi', 'zappi'],
  'NexBlue': ['nexblue'],
  'Obo Bettermann': ['obo bettermann'],
  'Sigenergy': ['sigenergy', 'sigenev'],
  'Sofar': ['sofar'],
  'SolarEdge': ['solaredge'],
  'Solplanet': ['solplanet'],
  'Sungrow': ['sungrow'],
  'Tesla': ['tesla'],
  'VOOL': ['vool'],
  'Voltie': ['voltie'],
  'Wallbox': ['wallbox pulsar', 'pulsar'],
  'Zaptec': ['zaptec'],
};

export const wallboxSellers = {
  '3ev': 'sklep.3ev.pl',
  'bezszelestni': 'bezszelestni.pl',
  'eltrox': 'eltrox.pl',
  'feyree': 'feyree.pl',
  'ladujev': 'sklep.ladujev.pl',
  'lenergizee': 'lenergizee.pl',
  'soltech': 'sklepsoltech.pl',
  'swiatbaterii': 'swiatbaterii.pl',
};

/**
 * Jeden katalog ładowarek — bez podziału na domowe i firmowe (pokrywały się w 87%).
 *
 * Zestaw filtrów wynika z audytu pokrycia atrybutów (`raport_jakosci.md`):
 * filtrujemy tylko po polach obecnych u co najmniej 70% produktów. Dlatego nie ma
 * tu klasy szczelności (66%), RFID (64%) ani licznika MID (67%) — te zostają na
 * karcie produktu. Filtr po parametrze, którego nie ma co trzeci produkt, wycina
 * katalog bez wiedzy użytkownika.
 */
export const wallboxFiltersSchema = [
  {
    // Przełącznik, nie osobna zakładka: stacji komercyjnych jest około 35 — za mało,
    // żeby uzasadnić własną sekcję, za dużo, żeby udawać, że ich nie ma.
    title: 'Stacje komercyjne',
    type: 'checkbox',
    name: 'komercyjne',
    values: {
      tak: 'Pokaż też stacje DC i wolnostojące',
    }
  },
  {
    title: 'Producent',
    type: 'checkbox',
    name: 'manufacturer',
    values: Object.keys(wallboxManufacturers).reduce((acc, key) => {
      acc[key] = key;
      return acc;
    }, {})
  },
  {
    // Klucze celowo z częścią dziesiętną ('11.0', nie '11'). JavaScript porządkuje
    // klucze wyglądające na liczby całkowite PRZED pozostałymi, więc '11' i '22'
    // wskakiwały przed '3.7' i '7.4' — stąd kolejność 11, 22, 3.7, 7.4 zamiast rosnącej.
    //
    // Każda wartość z kwalifikatorem prądu, spójnie z kartami produktu.
    // Moce DC dotyczą wyłącznie stacji komercyjnych — bez ich przełącznika
    // nie zwrócą żadnego wyniku.
    title: 'Moc ładowania',
    type: 'checkbox',
    name: 'power_kw',
    values: {
      '2.3': '2,3 kW AC',
      '3.7': '3,7 kW AC',
      '6.0': '6 kW AC',
      '7.0': '7 kW AC',
      '7.2': '7,2 kW AC',
      '7.4': '7,4 kW AC',
      '7.5': '7,5 kW AC',
      '8.0': '8 kW AC',
      '11.0': '11 kW AC',
      '13.8': '13,8 kW AC',
      '22.0': '22 kW AC',
      '30.0': '30 kW DC',
      '50.0': '50 kW DC',
      '60.0': '60 kW DC',
      '80.0': '80 kW DC',
      '120.0': '120 kW DC',
      '150.0': '150 kW DC',
      '160.0': '160 kW DC',
      '180.0': '180 kW DC',
      '240.0': '240 kW DC',
      '360.0': '360 kW DC',
    }
  },
  {
    title: 'Liczba faz',
    type: 'checkbox',
    name: 'phases',
    values: {
      '1': '1-fazowy',
      '3': '3-fazowy',
    }
  },
  {
    title: 'Złącze',
    type: 'checkbox',
    name: 'connector_types',
    values: {
      gniazdo_Type2: 'Gniazdo Type 2',
      kabel_Type2: 'Kabel Type 2',
      kabel_Type1: 'Kabel Type 1',
    }
  },
  {
    // Wartość "brak_danych" jest tu CELOWO widoczna dla użytkownika. Większość
    // katalogu nie ma potwierdzonych danych o ładowaniu nadwyżkami i musi to być
    // jawne — ukrycie tych produktów sugerowałoby, że funkcji nie mają.
    title: 'Ładowanie z fotowoltaiki',
    type: 'checkbox',
    name: 'pv_modes',
    values: {
      wlasny_licznik: 'Z dowolnym falownikiem (własny licznik)',
      tylko_falownik_tej_marki: 'Tylko z falownikiem tej samej marki',
      brak_danych: 'Brak potwierdzonych danych',
    }
  },
]
